import React from 'react';
import LegalPageLayout from '../../components/common/LegalPageLayout';

const TermsPage: React.FC = () => (
  <LegalPageLayout
    title="Terms of Service"
    updated="June 2026"
    intro="These Terms of Service (the “Terms”) govern your access to and use of the Debtornator website and the pre-launch product demonstration (the “Demo”). By accessing the site or the Demo, you agree to these Terms. Debtornator is pre-launch software with a planned general-availability date of Q3 2027; these Terms will be updated at launch."
    sections={[
      {
        heading: 'The Demo Is for Evaluation Only',
        body:
          'The Demo is provided solely so prospective customers and investors can evaluate Debtornator. It is a shared, read-only environment populated entirely with fictional data. It must not be used to manage real consumer, debtor, or account information, and it is not intended for production use.',
      },
      {
        heading: 'No Real Collection Activity',
        body:
          'No message, call, letter, or other communication generated within the Demo is delivered to any real person. The Demo simulates Debtornator’s compliance controls (FDCPA, TCPA, and related rules) for illustration; it does not constitute legal advice or a compliance determination for your business.',
      },
      {
        heading: 'Acceptable Use',
        body:
          'You agree not to: (a) attempt to access data or systems beyond the Demo; (b) probe, scan, or test the vulnerability of the environment without written authorization; (c) introduce malware or attempt to disrupt the service; or (d) use the Demo to develop a competing product. We may suspend access for any misuse.',
      },
      {
        heading: 'Accounts & Lead Information',
        body:
          'If you provide contact information to access the Demo, you consent to Debtornator contacting you about the product and its launch. See our Privacy Policy for how we handle that information.',
      },
      {
        heading: 'Intellectual Property',
        body:
          'The Debtornator name, logo, software, and content are owned by Debtornator and protected by intellectual-property laws. No license is granted except the limited right to access the Demo for evaluation.',
      },
      {
        heading: 'Disclaimers',
        body:
          'The site and Demo are provided “as is” and “as available,” without warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the Demo will be uninterrupted, error-free, or secure.',
      },
      {
        heading: 'Limitation of Liability',
        body:
          'To the maximum extent permitted by law, Debtornator will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of data, profits, or goodwill, arising from your use of the site or the Demo.',
      },
      {
        heading: 'Changes to These Terms',
        body:
          'We may update these Terms from time to time. Material changes will be reflected by the “Last updated” date above. Continued use after changes constitutes acceptance.',
      },
    ]}
  />
);

export default TermsPage;
